import styled from 'styled-components';

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const Points = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 13px;
  line-height: 18px;
  white-space: nowrap;
`;
